var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgX = function SvgX(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs-MVP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter---X---large",
    fill: "#9BAAB6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.19116373,4.77939902 L10.779399,4.77939902 C11.1692471,4.77939902 11.4852814,5.09543332 11.4852814,5.48528137 L11.4852814,5.48528137 C11.4852814,5.87512943 11.1692471,6.19116373 10.779399,6.19116373 L6.19116373,6.19116373 L6.19116373,10.779399 C6.19116373,11.1692471 5.87512943,11.4852814 5.48528137,11.4852814 L5.48528137,11.4852814 C5.09543332,11.4852814 4.77939902,11.1692471 4.77939902,10.779399 L4.77939902,6.19116373 L0.191163727,6.19116373 C-0.198684332,6.19116373 -0.514718626,5.87512943 -0.514718626,5.48528137 L-0.514718626,5.48528137 C-0.514718626,5.09543332 -0.198684332,4.77939902 0.191163727,4.77939902 L4.77939902,4.77939902 L4.77939902,0.191163727 C4.77939902,-0.198684332 5.09543332,-0.514718626 5.48528137,-0.514718626 L5.48528137,-0.514718626 C5.87512943,-0.514718626 6.19116373,-0.198684332 6.19116373,0.191163727 L6.19116373,4.77939902 Z",
    id: "+",
    transform: "translate(5.485281, 5.485281) rotate(-315.000000) translate(-5.485281, -5.485281) "
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgX);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/x.4340250b2d188d033b9bbb4db544a0a2.svg";